// src/components/UserList.js
import React, { useEffect, useState, useContext } from 'react';
import { 
  Table, 
  Button, 
  message, 
  Card, 
  Typography, 
  Space, 
  Row, 
  Col,
  Divider,
  Avatar,
  Tag,
  Tooltip
} from 'antd';
import { 
  EditOutlined, 
  UserOutlined, 
  MailOutlined 
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AppAdminLayout from "./components/AdminLayout";
import { LanguageContext } from "./LanguageContext";

const { Title, Text } = Typography;

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { language, setLanguage, translations } = useContext(LanguageContext);

  useEffect(() => {
    setLoading(true);
    axios.get('https://json-configrator-api.root.myoctoopidev.com/User/GetAll')
      .then(res => {
        if (res.data.success) {
          setUsers(res.data.data);
        } else {
          message.error('Veri alınamadı.');
        }
      })
      .catch(() => message.error('Sunucu hatası!'))
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleConfigClick = (id) => {
    localStorage.setItem('selectedUserId', id);
    navigate('/admineditableforuserjson');
  };

  const getInitials = (name, surname) => {
    return `${name?.[0] || ''}${surname?.[0] || ''}`.toUpperCase();
  };

  const columns = [
    {
      title: 'Kullanıcı',
      key: 'user',
      render: (_, record) => (
        <Space>
          <Avatar 
            style={{ backgroundColor: '#1890ff' }}
            icon={<UserOutlined />}
          >
            {getInitials(record.name, record.surname)}
          </Avatar>
          <div>
            <Text strong>
              {record.name} {record.surname}
            </Text>
            <br />
            <Text type="secondary" style={{ fontSize: '12px' }}>
              ID: #{record.id}
            </Text>
          </div>
        </Space>
      ),
    },
    {
      title: `${translations[language].adi}`,
      dataIndex: 'name',
      key: 'name',
      render: (name) => <Text>{name}</Text>
    },
    {
      title: `${translations[language].soyadi}`,
      dataIndex: 'surname',
      key: 'surname',
      render: (surname) => <Text>{surname}</Text>
    },
    {
      title: `${translations[language].email}`,
      dataIndex: 'email',
      key: 'email',
      render: (email) => (
        <Space>
          <MailOutlined style={{ color: '#1890ff' }} />
          <Text copyable>{email}</Text>
        </Space>
      )
    },
    {
      title: `${translations[language].işlem}`,
      key: 'action',
      width: 150,
      render: (_, record) => (
        <Tooltip title={translations[language].yke}>
          <Button 
            type="primary" 
            icon={<EditOutlined />}
            onClick={() => handleConfigClick(record.id)}
            style={{ borderRadius: '8px' }}
          >
            {translations[language].yke}
          </Button>
        </Tooltip>
      ),
    },
  ];

  return (
    <AppAdminLayout>
      <div style={{ padding: "24px", backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
        <Card 
          style={{ 
            borderRadius: "12px", 
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            border: "1px solid #e8e8e8"
          }}
        >
          {/* Header Section */}
          <Row justify="space-between" align="middle" style={{ marginBottom: "24px" }}>
            <Col>
              <Title level={3} style={{ margin: 0, color: "#1890ff" }}>
                Kullanıcı Listesi
              </Title>
              <Text type="secondary">
                {users.length} kullanıcı bulundu
              </Text>
            </Col>
            <Col>
              <Tag color="blue" style={{ padding: '4px 12px', fontSize: '14px' }}>
                Toplam: {users.length}
              </Tag>
            </Col>
          </Row>

          <Divider style={{ margin: "0 0 24px 0" }} />

          {/* Table Section */}
          <Table
            columns={columns}
            dataSource={users}
            rowKey="id"
            loading={loading}
            pagination={{
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ['5', '10', '20', '50'],
              showQuickJumper: true,
              showTotal: (total, range) => 
                `${range[0]}-${range[1]} of ${total} items`
            }}
            bordered
            style={{
              borderRadius: "8px",
              overflow: "hidden"
            }}
            rowClassName={(record, index) => 
              index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
            }
          />
        </Card>
      </div>

      <style jsx>{`
        .table-row-light {
          background-color: #fafafa;
        }
        .table-row-dark {
          background-color: #ffffff;
        }
        .ant-table-thead > tr > th {
          background-color: #f0f2f5;
          font-weight: 600;
        }
      `}</style>
    </AppAdminLayout>
  );
};

export default UserList;